import type { IconSvgObject } from './types';

const TrapezoidLineVerticalIcon: IconSvgObject = [
  ["path", { d: "M17.1939 19C18.411 19 19.346 17.922 19.1738 16.7171L17.7453 6.71894C17.6045 5.73381 16.7609 5.00203 15.7658 5.00183L8.23494 5.00034C7.23949 5.00015 6.39542 5.73206 6.25464 6.7175L4.82612 16.7172C4.654 17.922 5.58892 19 6.80602 19L17.1939 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 22L12 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TrapezoidLineVerticalIcon;
